import { render, staticRenderFns } from "./TemplatePopupImageThumbnail.vue?vue&type=template&id=1d06e098&"
import script from "./TemplatePopupImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./TemplatePopupImageThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports